import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { NzSkeletonModule } from 'ng-zorro-antd/skeleton';

/**
 * Skeleton loader for list items
 * Supports optional avatar/icon on the left
 */
@Component({
  selector: 'app-list-item-skeleton',
  standalone: true,
  imports: [CommonModule, NzSkeletonModule],
  templateUrl: './list-item-skeleton.component.html',
  styleUrls: ['./list-item-skeleton.component.scss'],
})
export class ListItemSkeletonComponent {
  /** Enable wave animation */
  @Input() active = true;
  
  /** Show avatar/icon placeholder */
  @Input() showAvatar = false;
  
  /** Number of paragraph rows */
  @Input() rows = 1;
  
  /** Title width (percentage or pixel value) */
  @Input() titleWidth: string | number = '50%';
}
